import {BaseView} from "../core/view"
import NavigationView from "./view"
import { MobileUtil } from "../utils/mobile";

let selector = '.js-side-navigation';

const bindEvents = {
    'click .js-navigation-vertical': 'loadVerticalSubCategories',
    'click .js-side-navigation-close': 'closeSideBar'
};

const css = {
    activeNavItem: 'navigation__verticals__item--active',
    showImageNavItem: 'navigation__verticals__item--show-image',
    categoriesVisible: 'navigation__categories--visible',
    sideNavOpen: 'navigation--menu-open',
    outerSideNavVisible: 'side-navigation--visible',
    outerSideNavOpen: 'side-navigation--open',
    bodyMenuOpen: 'is-navigation-menu-open'
};

export default class SideView extends BaseView{

    get el(){
        return selector;
    }

    set el(elem){
        selector = elem;
    }

    get events(){
        return bindEvents;
    }

    get cssClasses(){
        return css;
    }

    constructor(){
        super();
    }

    initialize(){
        if(!this.el) return;

        this.elements = {
            allNavigationVerticals: this.el.querySelectorAll('.js-navigation-vertical')
        };

        const images = this.el.querySelectorAll('.lazy-image');

        Array.prototype.forEach.call(images, (item) => {
            item.src = item.getAttribute('data-original');
        });

        const activeElement = this.el.querySelector(`.${this.cssClasses.activeNavItem}`);
        let activeVerticalData;
        if(activeElement){
            this.activeVertical = activeElement.getAttribute('data-vertical');
            activeVerticalData = this.activeVertical;
        }
        else{
            activeVerticalData = "neutral";
        }

        this.resetToActiveVertical(activeVerticalData);

        this.throttledCloseSideBar = _.throttle(() => {
            if(MobileUtil.isDesktop()) {
                this.closeSideBar();
            }
        }, 300);
    }

    getVertical(element){
        return NavigationView.prototype.getVertical.call(this, element);
    }

    resetToActiveVertical(dataKey){
        const activeVerticalElement = this.el.querySelector(`[data-vertical='${dataKey}']`);

        this.loadVerticalSubCategories(activeVerticalElement || "women");
    }

    loadVerticalSubCategories(e){
        NavigationView.prototype.loadVerticalSubCategories.call(this, e);
    }

    closeSideBar(){
        const self = this;
        this.el.classList.remove(this.cssClasses.outerSideNavOpen);
        document.querySelector('.js-navigation').classList.remove(this.cssClasses.sideNavOpen);
        document.body.classList.remove(this.cssClasses.bodyMenuOpen);
        setTimeout(() => {
            self.el.classList.remove(self.cssClasses.outerSideNavVisible);
            self.resetToActiveVertical.call(self);
        }, 300);
        window.removeEventListener('resize', self.throttledCloseSideBar.bind(self));
    }
}